import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
    TextField,
    Button,
    Checkbox,
    FormControlLabel,
    Link,
    Typography,
    Box,
} from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: "100vh",
        display: "flex",
        fontFamily: '"Plus Jakarta Sans", sans-serif',
    },
    authFrame: {
        position: "relative",
        backgroundImage: "linear-gradient(135deg, #7d12ce 0%, #5e0d9b 100%)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: theme.spacing(6),
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        color: "#fff",
        overflow: "hidden",
        [theme.breakpoints.down("md")]: {
            display: "none",
        },
    },
    authContent: {
        maxWidth: 500,
        marginBottom: theme.spacing(4),
        position: "relative",
        zIndex: 2,
    },
    authTitle: {
        fontSize: "2.5rem",
        fontWeight: 700,
        marginBottom: theme.spacing(2),
        color: "#fff",
    },
    authText: {
        fontSize: "1rem",
        lineHeight: 1.6,
        color: "rgba(255, 255, 255, 0.9)",
    },
    authImgs: {
        position: "relative",
        marginTop: theme.spacing(4),
        "& img": {
            maxWidth: "100%",
            height: "auto",
            borderRadius: "10px",
        },
        "& .img-fluid": {
            borderRadius: "10px",
        },
        "& .position1": {
            position: "absolute",
            top: "20%",
            right: "10%",
            width: "150px",
            animation: "$float 3s ease-in-out infinite",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
            borderRadius: "10px",
        },
        "& .position2": {
            position: "absolute",
            bottom: "10%",
            left: "15%",
            width: "120px",
            animation: "$float 4s ease-in-out infinite 0.5s",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
            borderRadius: "10px",
        },
    },
    "@keyframes float": {
        "0%, 100%": {
            transform: "translateY(0px)",
        },
        "50%": {
            transform: "translateY(-20px)",
        },
    },
    authFormSide: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.background.default,
    },
    authInner: {
        width: "100%",
        maxWidth: 450,
        padding: theme.spacing(4),
    },
    logoContainer: {
        textAlign: "center",
        marginBottom: theme.spacing(4),
    },
    logo: {
        maxWidth: 200,
        height: "auto",
    },
    welcomeText: {
        textAlign: "center",
        marginBottom: theme.spacing(5),
    },
    welcomeTitle: {
        fontSize: "1.3125rem",
        fontWeight: 600,
        marginBottom: theme.spacing(1),
        color: theme.palette.text.primary,
    },
    welcomeSubtitle: {
        fontSize: "0.875rem",
        color: theme.palette.text.secondary,
    },
    formLabel: {
        fontSize: "0.875rem",
        fontWeight: 500,
        marginBottom: theme.spacing(0.5),
        display: "block",
        color: theme.palette.text.primary,
    },
    textField: {
        marginBottom: theme.spacing(3),
        "& .MuiOutlinedInput-root": {
            borderRadius: "0.375rem",
            fontSize: "0.875rem",
            "& fieldset": {
                borderColor: "#E8EBF1",
            },
            "&:hover fieldset": {
                borderColor: "#7d12ce",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#7d12ce",
                borderWidth: 1,
            },
        },
        "& .MuiOutlinedInput-input": {
            padding: "12px 14px",
        },
    },
    rememberRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(3),
    },
    checkbox: {
        "& .MuiCheckbox-root": {
            padding: "4px 9px",
            color: "#7d12ce",
        },
        "& .MuiCheckbox-colorPrimary.Mui-checked": {
            color: "#7d12ce",
        },
        "& .MuiFormControlLabel-label": {
            fontSize: "0.875rem",
        },
    },
    forgotLink: {
        fontSize: "0.875rem",
        color: "#7d12ce",
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    loginButton: {
        backgroundColor: "#7d12ce",
        color: "#fff",
        padding: "12px",
        fontSize: "0.875rem",
        fontWeight: 600,
        borderRadius: "0.375rem",
        textTransform: "none",
        marginBottom: theme.spacing(3),
        "&:hover": {
            backgroundColor: "#5e0d9b",
        },
    },
}));

const LoginGxon = () => {
    const classes = useStyles();
    const history = useHistory();
    const { handleLogin } = React.useContext(AuthContext);

    const [user, setUser] = useState({ email: "", password: "" });
    const [rememberMe, setRememberMe] = useState(false);

    const handleChangeInput = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        handleLogin(user, rememberMe);
    };

    return (
        <Box className={classes.root}>
            {/* Left Side - Auth Frame */}
            <Box
                className={classes.authFrame}
                style={{
                    flex: 1,
                    backgroundImage: "linear-gradient(135deg, rgba(125, 18, 206, 0.95) 0%, rgba(94, 13, 155, 0.95) 100%), url(/auth/auth-bg.jpg)",
                    backgroundBlendMode: "overlay",
                }}
            >
                <Box className={classes.authContent}>
                    <Typography className={classes.authTitle}>
                        Bem-vindo de volta!
                    </Typography>
                    <Typography className={classes.authText}>
                        Nossa plataforma de atendimento garante que sua organização funcione de forma eficiente,
                        focando em pessoas, conformidade e eficiência para impulsionar o crescimento e a satisfação do cliente.
                    </Typography>
                </Box>
                <Box className={classes.authImgs}>
                    <img src="/auth/img1.png" alt="" className="img-fluid" />
                    <img src="/auth/img2.png" alt="" className="img-fluid position1" />
                    <img src="/auth/img3.png" alt="" className="img-fluid position2" />
                </Box>
            </Box>

            {/* Right Side - Login Form */}
            <Box className={classes.authFormSide} style={{ flex: 1 }}>
                <Box className={classes.authInner}>
                    {/* Logo */}
                    <Box className={classes.logoContainer}>
                        <img
                            src="https://dzapy.com.br/wp-content/uploads/2025/04/logoBr.png"
                            alt="Dzapy Logo"
                            className={classes.logo}
                        />
                    </Box>

                    {/* Welcome Text */}
                    <Box className={classes.welcomeText}>
                        <Typography className={classes.welcomeTitle}>
                            Bem-vindo ao Dzapy
                        </Typography>
                        <Typography className={classes.welcomeSubtitle}>
                            Faça login para acessar seu painel administrativo seguro.
                        </Typography>
                    </Box>

                    {/* Login Form */}
                    <form onSubmit={handleSubmit}>
                        {/* Email Field */}
                        <Box>
                            <label className={classes.formLabel}>Endereço de Email</label>
                            <TextField
                                variant="outlined"
                                fullWidth
                                name="email"
                                type="email"
                                placeholder="seu@email.com"
                                value={user.email}
                                onChange={handleChangeInput}
                                className={classes.textField}
                                required
                            />
                        </Box>

                        {/* Password Field */}
                        <Box>
                            <label className={classes.formLabel}>Senha</label>
                            <TextField
                                variant="outlined"
                                fullWidth
                                name="password"
                                type="password"
                                placeholder="********"
                                value={user.password}
                                onChange={handleChangeInput}
                                className={classes.textField}
                                required
                            />
                        </Box>

                        {/* Remember Me & Forgot Password */}
                        <Box className={classes.rememberRow}>
                            <FormControlLabel
                                className={classes.checkbox}
                                control={
                                    <Checkbox
                                        checked={rememberMe}
                                        onChange={(e) => setRememberMe(e.target.checked)}
                                        size="small"
                                    />
                                }
                                label="Lembrar-me"
                            />
                            <Link href="#" className={classes.forgotLink}>
                                Esqueceu a senha?
                            </Link>
                        </Box>

                        {/* Login Button */}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            className={classes.loginButton}
                        >
                            Entrar
                        </Button>
                    </form>
                </Box>
            </Box>
        </Box >
    );
};

export default LoginGxon;
